angular.module('com.vmware.platform.ui').directive('bottomPanel', [function () {
   return {
      restrict: 'E',
      templateUrl: 'resources/ui/views/mainlayout/AppBottomPanelView.html',
      link: function ($scope) {
         $scope.loader.bottomPanelViewLoaded = true;
      }
   };
}]);
